module.exports = __webpack_public_path__ + "static/media/photoreflective_switch.19ae6f15.gif";